var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPorcentajeGanancia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 86,
    viewBox: "0 0 99 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.3333 43.623V51.8897C96.3333 67.4453 87.4444 74.1119 74.1111 74.1119H36.3333",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44444 53.2222V25.2222C7.44444 9.66667 16.3333 3 29.6667 3H74.1111C87.4444 3 96.3333 9.66667 96.3333 25.2222",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38.5554C63 32.4221 58.0222 27.4443 51.8889 27.4443C45.7555 27.4443 40.7778 32.4221 40.7778 38.5554C40.7778 44.6888 45.7555 49.6666 51.8889 49.6666",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7778 27.4443V49.6666",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5556 65.2221C38.5556 68.5554 37.6223 71.711 35.9778 74.3777C32.9112 79.5332 27.2667 82.9999 20.7778 82.9999C14.2889 82.9999 8.6444 79.5332 5.57773 74.3777C3.93329 71.711 3 68.5554 3 65.2221C3 55.3999 10.9556 47.4443 20.7778 47.4443C30.6 47.4443 38.5556 55.3999 38.5556 65.2221Z",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3989 65.1338H14.1545",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7778 58.6445V71.9334",
    stroke: "#1A3D82",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorcentajeGanancia);
export default __webpack_public_path__ + "static/media/porcentajeGanancia.f06328388bd990d188b2f0e4c712eff1.svg";
export { ForwardRef as ReactComponent };